import clsx from "clsx";
import React from "react";
import "./faItemGroup.scss";

interface IFaItemGroupProps extends React.ComponentPropsWithoutRef<"div"> { }

export function FaItemGroup(props: IFaItemGroupProps) {
    return <div {...props} className={clsx("fa-item-group", props.className)} />;
}
